// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"e6-z"};